import React from 'react';
import { CardContent } from '@mui/material';
import { ExploreMoreCardWrapper, CardTitle, Description } from './styles';
import { ViewMoreLink } from '../common/ViewMoreLink';

export const ExploreMoreCard = () => {
  const link =
    'https://clinicalstudies.pkdcure.org/clinical-studies/?filter-custom-designation=&filter-custom-transplant=&filter-custom-mike=&filter-custom-age=&filter-custom-qualification=&';
  return (
    <ExploreMoreCardWrapper
      sx={{
        maxWidth : { xs: '100%', lg: '400px' },
        minWidth : '240px',
        flex     : 1,
      }}>
      <CardContent>
        <CardTitle
          variant='h6'>Study finding tool</CardTitle>
        <Description
          variant='pl3'>
          PKD has a study finding tool. Take a look in case you like to
          participate in more studies
        </Description>
        <ViewMoreLink
          to={link} target='_blank' isExternalLink>
          Explore more studies
        </ViewMoreLink>
      </CardContent>
    </ExploreMoreCardWrapper>
  );
};
